import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import BfIcon from "@/modules/abstract-ui/icon/BfIcon";
import { DefaultIcons } from "@/modules/abstract-ui/icon/DefaultIcons";
import DataBusDefaults from "@/services/DataBusDefaults";
// import "./ReloadTableButton.scss";

interface ReloadTableButtonProps {
  appearance?:
    | "default"
    | "primary"
    | "link"
    | "jump"
    | "clear"
    | "outline"
    | "outline-white"
    | "clear-on-white"
    | "clear-highlight"
    | "transparent-dark"
    | "transparent-light"
    | "debug";
  identifier: string;
}
const ReloadTableButton = (props: ReloadTableButtonProps) => {
  return (
    <BFButton
      appearance={props.appearance || "clear-on-white"}
      onClick={() => {
        DataBusDefaults.reload({
          identifiers: [props.identifier],
        });
      }}
    >
      <BfIcon {...DefaultIcons.REFRESH} size="xxs" />
    </BFButton>
  );
};

export default ReloadTableButton;
